export function toPlainText(html: string) {
  if (html == null) return html;
  return new DOMParser().parseFromString(html, 'text/html').body.textContent || '';
}

export function escapeHtml(html: string) {
  if (html == null) return html;
  return html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, "&#039;");
}

export function fileSizeToView(fileSize: number): string | null {
  if (fileSize == null) return null;
  const conversionParam: number = 1024;
  const units: Array<string> = ['B', 'kB', 'MB', 'GB'];
  if (fileSize < conversionParam) return `${fileSize.toString()}${units[0]}`;
  let i: number = 0;
  do {
    fileSize = fileSize / conversionParam;
    i++;
  } while (fileSize > conversionParam);
  return `${Math.max(fileSize, 0.1).toFixed(1).toString()}${units[i]}`;
}

export function formatEmpty(text: string) : string {
  return text ? text : '';
}

export function formatCsv(text: string) : string {
  let result = formatEmpty(text)
                  .replace(/"/g, '""');
  if (result.search(/("|,|\n)/g) >= 0)
    result = '"' + result + '"';
  return result;
}
